import { createEntityAdapter, createSlice, EntityState, PayloadAction } from '@reduxjs/toolkit';
import { RecipeNotification } from '../../api/models/recipe-notification.models';

const recipeNotificationAdapter = createEntityAdapter<RecipeNotification>({
  selectId: (data) => data.RecipeNotificationId,
  sortComparer: (a, b) => {
    if (a.NotificationType !== b.NotificationType) {
      return a.NotificationType - b.NotificationType;
    }

    if (a.DisplayTitle !== b.DisplayTitle) {
      return a.DisplayTitle.localeCompare(b.DisplayTitle);
    }

    return new Date(b.ChangeDate).getTime() - new Date(a.ChangeDate).getTime();
  },
});

type RecipeNotificationsState = {
  isRecipeNotificationsLoading: boolean;
  recipeNotifications: EntityState<RecipeNotification>;
  isActiveCountLoading: boolean;
  activeCount: number;
};

const initialState: RecipeNotificationsState = {
  isRecipeNotificationsLoading: false,
  recipeNotifications: recipeNotificationAdapter.getInitialState(),
  isActiveCountLoading: false,
  activeCount: 0,
};

export const recipeNotificationsSlice = createSlice({
  initialState,
  name: 'recipeNotifications',
  reducers: {
    setIsRecipeNotificationsLoading: (state: RecipeNotificationsState, action: PayloadAction<boolean>) => {
      state.isRecipeNotificationsLoading = action.payload;
    },
    setRecipeNotifications: (state: RecipeNotificationsState, action: PayloadAction<RecipeNotification[]>) => {
      recipeNotificationAdapter.setAll(state.recipeNotifications, action.payload);
    },
    setIsActiveCountLoading: (state: RecipeNotificationsState, action: PayloadAction<boolean>) => {
      state.isActiveCountLoading = action.payload;
    },
    setActiveCount: (state: RecipeNotificationsState, action: PayloadAction<number>) => {
      state.activeCount = action.payload;
    },
    removeRecipeNotification: (state: RecipeNotificationsState, action: PayloadAction<string>) => {
      recipeNotificationAdapter.removeOne(state.recipeNotifications, action.payload);
    },
  },
});

export const { selectAll: selectAllRecipeNotifications } = recipeNotificationAdapter.getSelectors();
